/* eslint-disable no-console */
/* eslint-disable */

import { register } from 'register-service-worker'
// import { getFirebaseInstance } from './utils/firebase'

export function registerWorker ({bar, store, notify, translate, emitter}) {
  if (process.env.NODE_ENV === 'production') {
    console.log('Init registerWorker')
    let isReady = false
    let fb = null
    let refreshing = false
    let installing = false

    register(`${process.env.BASE_URL}service-worker.js`, {
      registered (registration) {
        console.log('Service worker has been registered.')
        if (isReady === true) {
          // uncoment for enable service workers
          // and push notifications
          /* fb = getFirebaseInstance()
          fb.initFirebase(registration).then(() => {
            return fb.initMessaging()
          }).then(() => {
            return fb.getFcmToken()
          }).then(token => {
            console.log('success get token', token)
            emitter.emit('serviceWorker.fcmToken', token)
          }).catch(e => {
            console.error('get token error', e)
          }) */
        }
      },
      cached () {
        installing = true
        console.log('Content has been cached for offline use.')
        // we must reload page for correct registration
        // we can't have the SW controlling on the first load because the page has to
        // load before it can register the SW
        if (isReady === false) {
          console.log('full reload after install')
          window.location.reload()
        } else {
          bar.unLockAppBootstrap()
        }
      },
      updatefound () {
        console.log('New content is downloading.')
      },
      updated (registration) {
        console.log('New content is available; please refresh.')
        let notMsg = notify.warning({
          type: 'success',
          title: translate.translate('Доступно обновление'),
          message: `
          <p>
          ${translate.translate('Вы используете устаревшую версию приложения, некоторые функции могут работать неверно. Обновить приложение?')}
          </p>
          <p style="text-align: center">
             <button
             type="button"
             class="actions-filter-panel__button standart update"
             >
             ${translate.translate('Обновить')}
             </button>
          </p>
          `,
          dangerouslyUseHTMLString: true,
          duration: (60 * 1000)
        })
        setTimeout(() => {
          const updBtn = notMsg.$el && notMsg.$el.querySelector('.update')
          updBtn && updBtn.addEventListener('click', (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            bar.startOrContinue()
            console.log('service worker REGISTERED')
            bar.showAppBootsrap()
            const worker = registration.waiting
            worker.postMessage({action: 'skipWaiting'})
          })
        }, 0)
      },
      offline () {
        console.log('No internet connection found. App is running in offline mode.')
      },
      error (error) {
        bar.unLockAppBootstrap()
        bar.finish()
        console.error('Error during service worker registration:', error)
      }
    })

    if (navigator.serviceWorker) {
      // register-service-worker module call ready only on localhost
      // use own ready function
      navigator.serviceWorker.ready.then(function () {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        )
        isReady = true
        if (installing === true) return
        bar.unLockAppBootstrap()
      })

      // need for update data in pwa
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing === true) return
        window.location.reload()
        refreshing = true
      })

      // main message stream from worker
      navigator.serviceWorker.addEventListener("message", msg =>{
        console.log('serviceWorker.message', msg.data)
        emitter.emit('serviceWorker.message', msg.data)
      })
    } else {
      console.warn('cant find navigator.serviceWorker')
      bar.unLockAppBootstrap()
    }
  } else {
    bar.unLockAppBootstrap()
  }
}
